module.exports = __webpack_public_path__ + "img/资金特发管理.bf725938.svg";